import {
  SidebarMenuButton,
  SidebarMenuItem,
} from "@babackapp/ui/components/sidebar";
import React from "react";
import { Link, useLocation } from "react-router-dom";

type NavigationSectionItemProps = {
  to?: string;
  icon?: React.ReactNode;
  label: string;
};

export function NavigationSectionItem({
  to,
  icon,
  label,
}: NavigationSectionItemProps) {
  const { pathname } = useLocation();

  const selected = pathname === to;

  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild isActive={selected}>
        <Link to={to ?? "#"}>
          {icon}
          <span>{label}</span>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}
